module.exports = __webpack_public_path__ + "img/Flag_of_Ukraine.1aeecd60.svg";